import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var MLPackageVersionViewMode;
(function (MLPackageVersionViewMode) {
    MLPackageVersionViewMode[MLPackageVersionViewMode["InputOutput"] = 0] = "InputOutput";
    MLPackageVersionViewMode[MLPackageVersionViewMode["ReleaseNotes"] = 1] = "ReleaseNotes";
})(MLPackageVersionViewMode || (MLPackageVersionViewMode = {}));
var MLPackageVersionsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MLPackageVersionsModalComponent, _super);
    function MLPackageVersionsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ModelVersionViewMode = MLPackageVersionViewMode;
        return _this;
    }
    MLPackageVersionsModalComponent.prototype.onClose = function (result) {
        var data = result ?
            { type: 3 /* Remove */ } :
            undefined;
        this._dialogRef.close(data);
    };
    MLPackageVersionsModalComponent.prototype.showVersions = function () {
        this.selectedModelVersion = undefined;
    };
    MLPackageVersionsModalComponent.prototype.showInformation = function (modelVersion, mode) {
        this.currentModelVersionViewMode = mode;
        this.selectedModelVersion = modelVersion;
    };
    return MLPackageVersionsModalComponent;
}(UiModalComponent));
export { MLPackageVersionsModalComponent };
